import { fadeColor, getColor, lightenColor, styled } from "imaginarity-react-ui";

export namespace DurationInputSC {

    export const Container = styled.div<{ minimized: boolean, maximized: boolean, cleareable: boolean, miniDevice: boolean, error: boolean, noMinutes: boolean }>`
    width:   ${p => p.maximized ? "100%" : (p.minimized && !p.cleareable) ? "128px" : (p.minimized && p.cleareable) ? "162px" : (p.cleareable && !p.miniDevice ? "302px" : "262px")};
    display: grid;
    grid-template-columns: ${p => p.maximized ? p.noMinutes ? "1fr 1fr" : "1fr 1fr 1fr" : p.minimized ? p.noMinutes ? "42px 42px" : "42px 42px 42px" : p.noMinutes ? "80px 80px" : "80px 80px 100px"} ${p => p.cleareable && "40px"};
    column-gap: 0px;
    height: ${p => p.minimized ? "80px" : p.miniDevice ? "80px" : "40px"};
    line-height: ${p => p.miniDevice ? "28px" : "40px"};
    border: 1px solid ${p => lightenColor(p, p.theme.backgroundColor, 80)};
    position: relative;    
    input{
        text-align: ${p => p.minimized ? "center" : "left"};
        ${p => p.error && `background: ${fadeColor(p, "@accentRed", 5)};`}
    }
`;
    export const Column = styled.div<{ miniDevice?: boolean }>`
    position: relative;
    height: ${p => p.miniDevice ? "38px" : "38px"};
    &:hover{
        background:  ${p => fadeColor(p, "@darkGrey", 5)};
    }
`;
    export const Btn = styled.div<{ miniDevice?: boolean, minimized?: boolean }>`
    border-left: ${p => p.minimized && !p.miniDevice ? "none" : `1px solid ${lightenColor(p, p.theme.backgroundColor, 80)}}`};
    height: ${p => p.miniDevice ? 78 : p.minimized ? 78 : 38}px;
    width: 40px;
    text-align: center;
    overflow: hidden;
    background: ${p => p.minimized || p.miniDevice ? lightenColor(p, "backgroundColor", 97) : "transparent"};
    &>div{ margin:0;}
    button{
        height: 38px;
        border-bottom: ${p => p.minimized && !p.miniDevice ? `1px solid ${lightenColor(p, "backgroundColor", 97)}}` : "none"};
    }
    svg{
        transform: translate(-2px,-3px);
    }
`;
    export const Unit = styled.div<{ unit: string }>`
    position: absolute;
    top: -1px;
    right: 25px;
    height: 40px; 
    line-height: 40px;
    text-align: right;
    font-size: 1em;
    pointer-events: none;
    &::after{
        content: '${p => p.unit}';
        color: ${p => getColor(p, "color")};
        }
`;
    export const UnitMinimized = styled.div`
    position: absolute;
    bottom: -20px;
    line-height: 20px;
    font-size: 0.8em;
    left: 0;
    width: 40px;
    text-align: center;
    color: ${p => getColor(p, "color")};
    
`;
    export const CountUp = styled.div<{ minimized?: boolean }>`
    position: absolute;
    top: ${p => p.minimized ? "unset" : "4px"};
    left: ${p => p.minimized ? "unset" : "unset"};
    right: ${p => p.minimized ? "4px" : "3px"};
    bottom: ${p => p.minimized ? "-35px" : "unset"};
    height: 16px;
    width: 16px;
    line-height: 16px;
    text-align: center;
    background:  ${p => getColor(p, "backgroundColor")};
    transition: all 0.2s ease-out;
    border: 1px solid ${p => lightenColor(p, p.theme.backgroundColor, 90)};
    ${p => p.minimized && "border-left: none;"}
    cursor: pointer;
    &:hover{
        background:  ${p => getColor(p, "@accent")};
        svg{
            stroke: ${p => getColor(p, "@mainBackground")};
        }
    }
`;
    export const CountDown = styled(CountUp)`
    top: unset;
    right: 3px;
    left: ${p => p.minimized ? "4px" : "unset"};
    bottom: ${p => p.minimized ? "-35px" : "3px"};
    border: 1px solid ${p => lightenColor(p, p.theme.backgroundColor, 90)};
    
    ${p => !p.minimized && "border-top: none;"}
    ${p => p.minimized && "border-right: none;"}
`;
    export const Title = styled.div<{ minimized: boolean, maximized: boolean, titleMode?: "title" | "info" | "both", cleareable?: boolean, miniDevice?: boolean }>`
        display: grid;
        grid-template-columns: ${p => p.titleMode === "both" ? "max-content 1fr" : "1fr"};
        line-height: 20px;
        font-size: 0.85em;
        padding: 0 5px;
        //border: ${p => `1px solid ${lightenColor(p, p.theme.backgroundColor, 80)}`};
        //border-bottom: none;     
        width: ${p => p.maximized ? "100%" : (p.minimized && !p.cleareable) ? "128px" : (p.minimized && p.cleareable) ? "162px" : (p.cleareable && !p.miniDevice ? "302px" : "262px")};
        background: ${p => fadeColor(p, p.theme.colors.accentBlack, 5)};
        color: ${p => getColor(p, "color")};
    `;
    export const TitleText = styled.div`     
        width: 100%;          
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    `;
    export const TitleInfo = styled.div<{ hasError?: boolean }>`   
        width: 100%;          
        text-align: right;
        font-size: 0.9em;            
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        ${p => p.hasError && `color: ${getColor(p, "@accentRed")};`}
    `;
    export const DIRContainer = styled.div<{ maximized?: boolean, singleColumn?: boolean, gap?: number | "fillRest", confirmEntry?: boolean, clearable?: boolean }>`
        width: ${p => p.maximized || p.gap === "fillRest" ? "100%" : "fit-content"};
        display: grid;
        grid-template-columns: ${p => p.singleColumn ? "1fr" : p.gap === "fillRest" ? "max-content 1fr max-content" : "1fr 1fr"} ${p => (p.confirmEntry || p.clearable) && "max-content"}; 
        column-gap: ${p => p.singleColumn ? 0 : (p.gap === "fillRest" ? 0 : p.gap ? p.gap : 40)}px; 
        row-gap: ${p => p.singleColumn ? (p.gap ?? 10) : 0}px;
        button>div{margin: 0;}
        
`;
    export const DIRErrorInfo = styled.div<{ singleColumn?: boolean }>`
        grid-column-start: ${p => p.singleColumn ? 1 : 2};
        grid-column-end: ${p => p.singleColumn ? 2 : 3};
        line-height: 20px;
        font-size: 0.85em;
        color: ${p => getColor(p, "@accentRed")};
`;
    export const DIRContainerInput = styled.div<{ changed: boolean }>`
        input{
        ${p => p.changed && `background: ${fadeColor(p, "@accentBlue", 10)};`}
    }
`;
    export const InfoAllEntries = styled.div`
        float: left;
        padding-left: 5px;
        margin-top: -5px;
`;

}